<template>
  <v-container
    id="deductionTab"
    class="pa-0"
  >
    <base-resource-grid
      color="green"
      icon="mdi-pen-minus"
      plural-name="Deduction"
      singular-name="Deduction"
      allow-expand
      :headers="gridHeaders"
      :resource="deductionResource"
      :fetch-method="getDeduction"
      :actions="actions"
      :prepare-save="prepareSave"
      :disabled="disabled"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
      @item:deleted="itemChanged"
    >
      <template
        v-slot:editForm="bindings"
        class="pa-0"
      >
        <deduction-edit
          v-model="bindings.editedItem"
          class="pa-0"
          :open-enrollment="openEnrollment"
          :form-errors="bindings.formErrors"
          :disabled="disabled"
        />
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="oeDeductionHistory/"
      id-field="oeDeductionId"
      title-field="Deduction"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'DeductionTab',

    components: {
      DeductionEdit: () => import('./DeductionEdit'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      gridHeaders: [
        {
          text: 'Title',
          value: 'title',
        },
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Code',
          value: 'code',
        },
        {
          text: 'Tax Status',
          value: 'taxStatus',
        },
        {
          text: 'Status',
          value: 'status',
        },
      ],

      historyColumns: [
        {
          text: 'Title',
          value: 'title',
        },
        {
          text: 'Product',
          value: 'product',
        },
        {
          text: 'Carrier',
          value: 'carrier',
        },
        {
          text: 'Code',
          value: 'code',
        },
        {
          text: 'Tax Status',
          value: 'taxStatus',
        },
        {
          text: 'Status',
          value: 'status',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      deductionResource: new TroodyApi('oeDeduction/'),

      historyItem: null,
    }),

    methods: {
      getDeduction () {
        return this.deductionResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id
        }
        return payload
      },
    },
  }
</script>
